(() => {
  if (customElements.get('nl-hallbergs-gallery')) return;
  class HallbergsGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.config = JSON.parse(this.querySelector('[data-hg-config]').textContent);
        this.variants = JSON.parse(this.querySelector('[data-hg-variants]').textContent);
      } catch (_) { return; }
      this.page = this.closest('[data-js-product-component]');
      this.original = this.parentElement.querySelector('[data-hg-original]');
      if (!this.page || !this.original) return;
      this.image = this.querySelector('[data-hg-image]');
      this.scene = this.querySelector('.nl-hg-scene');
      this.tabs = this.querySelector('.nl-hg-tabs');
      this.buttons = [...this.querySelectorAll('[data-hg-view]')];
      this.tabs.hidden = false;
      this.view = 'interior';
      this.onClick = (event) => {
        const button = event.target.closest('[data-hg-view]');
        if (!button || button.disabled) return;
        this.view = button.dataset.hgView;
        this.paint();
      };
      this.onVariant = () => this.sync();
      this.addEventListener('click', this.onClick);
      // Native VARIANT_CHANGE is non-bubbling: capture it from the product root.
      this.page.addEventListener('VARIANT_CHANGE', this.onVariant, true);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.page, {childList:true,subtree:true});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.page?.removeEventListener('VARIANT_CHANGE', this.onVariant, true);
      this.ready = false;
    }
    sync() {
      let variant;
      const data = this.page.querySelector('[data-js-variant-data]');
      try { variant = data && JSON.parse(data.textContent); } catch (_) {}
      const nativeId = this.page.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      variant = this.variants[String(variant?.id || nativeId)] ||
        (!data && !nativeId ? Object.values(this.variants).find(v => v.sku === this.dataset.initialSku) : null);
      const sku = variant?.sku || '';
      if (this.variantKey === `${sku}:${variant?.available}`) return;
      this.variantKey = `${sku}:${variant?.available}`;
      const asset = this.config.variants?.[sku];
      this.asset = variant?.available && asset?.approved === true && this.safeUrl(asset.url) ? asset : null;
      this.variantTitle = variant?.title || '';
      this.paint();
    }
    safeUrl(value) {
      try { const u = new URL(value); return u.protocol === 'https:' && u.hostname === 'cdn.shopify.com'; }
      catch (_) { return false; }
    }
    paint() {
      const interior = this.view === 'interior' && !!this.asset;
      this.buttons.forEach(button => {
        button.disabled = button.dataset.hgView === 'interior' && !this.asset;
        button.setAttribute('aria-pressed', String(button.dataset.hgView === (interior ? 'interior' : 'original')));
      });
      if (!interior) {
        const wasHidden = this.original.hidden;
        this.scene.hidden = true;
        this.original.hidden = false;
        if (wasHidden) window.dispatchEvent(new Event('resize'));
        return;
      }
      const sku = this.variantKey;
      const url = new URL(this.asset.url); url.searchParams.set('width', '1122');
      if (this.image.getAttribute('src') !== url.href) {
        this.image.setAttribute('data-loading', '');
        this.image.onload = () => {
          if (sku !== this.variantKey || this.view !== 'interior') return;
          this.image.removeAttribute('data-loading');
          this.original.hidden = true;
          this.scene.hidden = false;
        };
        this.image.onerror = () => {
          if (sku !== this.variantKey) return;
          this.asset = null;
          this.paint();
        };
        // A previous colour must never remain visible while a new one loads.
        this.scene.hidden = true;
        this.original.hidden = false;
        this.image.alt = `${this.dataset.productTitle} – ${this.variantTitle} – ${this.dataset.locale === 'sv' ? 'Miljöbild' : 'Miljöökuva'}`;
        this.querySelector('[data-hg-caption]').textContent = this.variantTitle;
        this.image.srcset = [600, 900, 1122].map(width => { const src = new URL(this.asset.url); src.searchParams.set('width', String(width)); return `${src.href} ${width}w`; }).join(', ');
        this.image.src = url.href;
      } else if (this.image.complete && this.image.naturalWidth) {
        this.original.hidden = true;
        this.scene.hidden = false;
      }
    }
  }
  customElements.define('nl-hallbergs-gallery', HallbergsGallery);
})();
